export default {
  '系统默认样式': 'System Default Style',
  '重打印': 'Reprint',
  '店铺编号print': 'Shop',
  '单据日期': 'Date',
  '核销单号print': 'Trans',
  '定金单号': 'Deposit Receipt No.',
  '小票号print': 'Invoice #',
  '操作时间print': 'Time',
  '收银员print': 'Cashier',
  '营业员print': 'Staff',
  '店铺电话print': 'Phone',
  '店铺手机print': 'Mobile',
  '会员编号print': 'VIP Code',
  '会员姓名print': 'Member Name',
  '会员等级print': 'VIP Level',
  '销售备注print': 'Remarks',
  '店铺地址print': 'Address',
  '已中所有促销': 'In all promotion',
  '已中整单促销': 'In Promotion',
  '总额print': 'Total Amount',
  '优惠print': 'Discount',
  '应付print': 'Net',
  '找零': 'Change',
  '积分': 'Points',
  '支付流水号': 'Payment Serial No.',
  '获得积分print': 'Gain Point',
  '积分余额print': 'Balance',
  '储值余额print': 'Pre-paid Amount',
  '代用券券号': 'Coupon Code',
  '顾客签名': 'Signature',
  '该单所有的促销': 'All Promotions on this Ticket',
  '促销描述': 'Promotion Description',
  '货品print': 'Items',
  '吊牌价print': 'Price',
  '会员价': 'VIP Price',
  '折后价print': 'Net Price',
  '零售折扣/折后价': '零售折扣/折后价',
  '零售价print': '零售价',
  '零售折扣print': '零售折扣',
  '折扣/折后价': 'DCT/NET Price',
  '折扣print': 'Discount',
  '数量print': 'Qty',
  '金额print': 'Amount',
  '合计print': 'Total',
  '会员print': 'VIP No#',
  '顾客联': 'Customer Version',
  '店铺联': 'Shop Version',
  '税额/金额': 'TAX/Amt',
  '税额': 'GST Amt',
  '代用券': 'Coupon',
  '不限': 'Un-Limit',
  '满-金额': 'Amt ',
  '可用': ' Available',
  '店铺': 'Channel',
  '广州市番禺区天安节能科技园15号楼': 'Tian\'an Energy-saving Science and Technology Park, Panyu District, Guangzhou',
  '买满送优惠券': 'Coupon back at certain amt',
  '买满打折(按货品)': 'Deduct at certain Amt (by Goods)',
  '买满立减(按单)': 'Deduct at certain Amt (by Bill)',
  '王晓': 'Wang Xiao',
  '快递费': '快递费',
  '金属感香槟灰': '金属感香槟灰',
  '长袖上衣': '长袖上衣',
  'FS OTH 男装运动套头衫': 'FS OTH 男装运动套头衫',
  '现金支付': 'Cash',
  '高级会员': 'Higher',
  '方某某': 'Mr Fang',
  '张三': 'Zhang San',
  '日期': 'Date'
}



// WEBPACK FOOTER //
// ./src/i18n/en/preview.js